module.exports = __webpack_public_path__ + "img/zuanshi.b19f1a2e.svg";